"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHrConfig = exports.defaultTitleConfig = void 0;
var defaultTitleConfig = {
    margin: {
        desktop: '0 0 50px',
        tablet: '0 0 50px',
        mobile: '0 0 50px'
    },
    padding: {
        desktop: 0,
        tablet: 0,
        mobile: 0
    },
    textAlign: 'center',
    textTransform: 'none',
    fontWeight: 'normal'
};
exports.defaultTitleConfig = defaultTitleConfig;
var defaultHrConfig = {};
exports.defaultHrConfig = defaultHrConfig;
//# sourceMappingURL=Title.js.map